import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import styles, { iframeStyle } from './styles';
/* eslint-disable react/require-default-props */
export interface PdfPanelProps {
  title: string;
  pdfUrl: string;
  isLoading: boolean;
  iframeTitle: string;
  error?: string;
  emptyMessage?: string;
  hideHeader?: boolean;
}

const PdfPanel = ({
  title,
  pdfUrl,
  isLoading,
  iframeTitle,
  error = '',
  emptyMessage = '',
  hideHeader = false
}: PdfPanelProps) => {
  const ErrorComponent = useMemo(() => {
    if (!error || isLoading) return null;
    return (
      <Box sx={styles.errorWrapper}>
        <Typography variant='body2' color='text.secondary'>
          {error}
        </Typography>
      </Box>
    );
  }, [error, isLoading]);

  const PdfIframe = useMemo(() => {
    if (!pdfUrl || isLoading) return null;
    return <iframe src={pdfUrl} title={iframeTitle} style={iframeStyle} />;
  }, [pdfUrl, isLoading, iframeTitle]);

  const EmptyStateComponent = useMemo(() => {
    if (pdfUrl || isLoading || error || !emptyMessage) return null;
    return (
      <Box sx={styles.emptyStateWrapper}>
        <Typography variant='body2' color='text.secondary'>
          {emptyMessage}
        </Typography>
      </Box>
    );
  }, [pdfUrl, isLoading, error, emptyMessage]);

  return (
    <Box sx={styles.panel}>
      {!hideHeader && (
        <Box sx={styles.panelHeader}>
          <Typography variant='body2' fontWeight={500}>
            {title}
          </Typography>
        </Box>
      )}
      <Box sx={styles.panelContent}>
        {isLoading && (
          <Box sx={styles.loadingSpinnerWrapper}>
            <CircularProgress size={32} />
          </Box>
        )}
        {ErrorComponent}
        {PdfIframe}
        {EmptyStateComponent}
      </Box>
    </Box>
  );
};

export default PdfPanel;
